import { createGlobalStyle } from 'styled-components';
import styledNormalize from 'styled-normalize';
import {
  BLACK,
  MEDIUM_GRAY,
  H1,
  H2,
  H3,
  H4,
} from 'root/theme';

// Whole lotta type imports

import Ms800ttf from 'assets/fonts/montserrat-v13-latin-800.ttf';
import Ms800Woff2 from 'assets/fonts/montserrat-v13-latin-800.woff2';
import Ms800Woff from 'assets/fonts/montserrat-v13-latin-800.woff';
import Ms800Eot from 'assets/fonts/montserrat-v13-latin-800.eot';

import Ms600ttf from 'assets/fonts/montserrat-v13-latin-600.ttf';
import Ms600Woff2 from 'assets/fonts/montserrat-v13-latin-600.woff2';
import Ms600Woff from 'assets/fonts/montserrat-v13-latin-600.woff';
import Ms600Eot from 'assets/fonts/montserrat-v13-latin-600.eot';

import Ms400ittf from 'assets/fonts/montserrat-v13-latin-italic.ttf';
import Ms400iWoff2 from 'assets/fonts/montserrat-v13-latin-italic.woff2';
import Ms400iWoff from 'assets/fonts/montserrat-v13-latin-italic.woff';
import Ms400iEot from 'assets/fonts/montserrat-v13-latin-italic.eot';

import Ms400ttf from 'assets/fonts/montserrat-v13-latin-regular.ttf';
import Ms400Woff2 from 'assets/fonts/montserrat-v13-latin-regular.woff2';
import Ms400Woff from 'assets/fonts/montserrat-v13-latin-regular.woff';
import Ms400Eot from 'assets/fonts/montserrat-v13-latin-regular.eot';

// eslint-disable-next-line
const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 400;
    src: local('Montserrat Regular'), local('Montserrat-Regular'),
      url(${Ms400Eot}) format('embedded-opentype'), /* IE6-IE8 */
      url(${Ms400Woff2}) format('woff2'), /* Super Modern Browsers */
      url(${Ms400Woff}) format('woff'), /* Modern Browsers */
      url(${Ms400ttf}) format('truetype'); /* Safari, Android, iOS */
  }

  @font-face {
    font-family: 'Montserrat';
    font-style: italic;
    font-weight: 400;
    src: local('Montserrat Italic'), local('Montserrat-Italic'),
      url(${Ms400iEot}) format('embedded-opentype'), /* IE6-IE8 */
      url(${Ms400iWoff2}) format('woff2'), /* Super Modern Browsers */
      url(${Ms400iWoff}) format('woff'), /* Modern Browsers */
      url(${Ms400ittf}) format('truetype'); /* Safari, Android, iOS */
  }

  @font-face {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    src: local('Montserrat SemiBold'), local('Montserrat-SemiBold'),
      url(${Ms600Eot}) format('embedded-opentype'), /* IE6-IE8 */
      url(${Ms600Woff2}) format('woff2'), /* Super Modern Browsers */
      url(${Ms600Woff}) format('woff'), /* Modern Browsers */
      url(${Ms600ttf}) format('truetype'); /* Safari, Android, iOS */
  }

  /* montserrat-800 - latin */
  @font-face {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 800;
    src: local('Montserrat ExtraBold'), local('Montserrat-ExtraBold'),
      url(${Ms800Eot}) format('embedded-opentype'), /* IE6-IE8 */
      url(${Ms800Woff2}) format('woff2'), /* Super Modern Browsers */
      url(${Ms800Woff}) format('woff'), /* Modern Browsers */
      url(${Ms800ttf}) format('truetype'); /* Safari, Android, iOS */
  }

  ${styledNormalize}

  * {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    box-sizing: border-box;
  }

  *:before,
  *:after {
    box-sizing: border-box;
  }

  html, body, #root {
    height: 100%;
    font-size: 16px;
    font-family: 'Montserrat', helvetica, arial, sans-serif;
    line-height: 1.5;
    color: ${MEDIUM_GRAY};
    background-color: ${BLACK};
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  body {
    margin: 0;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    color: inherit;
    font: inherit;
    margin: 0;
  }

  input,
  button,
  select,
  textarea {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }

  img {
    vertical-align: middle;
  }

  table {
    border-collapse: collapse;
  }

  h1 {
    ${H1}
  }

  h2 {
    ${H2}
  }

  h3 {
    ${H3}
  }

  h4 {
    ${H4}
  }
`;

export default GlobalStyle;
